module.exports = __webpack_public_path__ + "img/home_bg2.f09fc5e7.png";